import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as authActions from '../actions/auth';
import { Link } from 'react-router-dom';

class Footer extends React.Component {
  render() {
    return (
      <footer className="Footer bt-1 text-gray">

        <div className="bg-linen py-5">
          <div className="container">
            <section className="footer-links row py-4 justify-content-md-center">
              <div className="col-12 col-sm-6 col-md-5 col-lg-3 mb-gutter">
                <h6 className="footer-nav-heading">Localvore</h6>
                <nav className="nav flex-column">
                  <li className="nav-item">
                    <a
                      className="text-gray-dark nav-link"
                      href="https://pages.localvore.co/about-us"
                    >
                      About
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="text-gray-dark nav-link"
                      href="https://pages.localvore.co/press"
                    >
                      Press
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="text-gray-dark nav-link"
                      href="https://pages.localvore.co/team"
                    >
                      Team
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="text-gray-dark nav-link"
                      href="https://pages.localvore.co/careers"
                    >
                      Careers
                    </a>
                  </li>
                </nav>
              </div>
              <div className="col-12 col-sm-6 col-md-5 col-lg-3 mb-gutter">
                <h6 className="footer-nav-heading">Support</h6>
                <nav className="nav flex-column">
                  <li className="nav-item">
                    <a
                      className="text-gray-dark nav-link"
                      href="https://pages.localvore.co/policies"
                    >
                      Policies
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="text-gray-dark nav-link"
                      href="mailto:help@localvore.co"
                    >
                      Help
                    </a>
                  </li>
                </nav>
              </div>
              <div className="col-12 col-sm-6 col-md-5 col-lg-3 mb-gutter">
                <h6 className="footer-nav-heading">Partners</h6>
                <nav className="nav flex-column">
                  <li className="nav-item">
                    <a
                      className="text-gray-dark nav-link"
                      href="https://merchants.localvore.co"
                    >
                      Get your Business on Localvore
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="text-gray-dark nav-link"
                      onClick={this.props._auth.toggleAuthenticationModal}
                    >
                      Sign In / Sign Up
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="text-gray-dark nav-link"
                      href="https://merchants.localvore.co"
                    >
                      Merchant Dashboard
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="text-gray-dark nav-link"
                      href="https://pages.localvore.co/contact"
                    >
                      Contact Us
                    </a>
                  </li>
                </nav>
              </div>
              <div className="col-12 col-sm-6 col-md-5 col-lg-3 mb-gutter">
                <h6 className="footer-nav-heading">#fortheloveoflocal</h6>
                <div className="d-flex justify-md-content-between footer-icons pl-3">
                  <Link
                    to="/"
                    className="footer-icon-link text-tomato"
                    title="Home"
                  >
                    <span className="fa fa-stack">
                      <i
                        className="fa fa-stack-2x icon-lv-logo text-tomato"
                        aria-hidden="true"
                      />
                    </span>
                    <span className="sr-only">Home</span>
                  </Link>
                  <a
                    href="https://facebook.com/LocalvoreToday"
                    className="footer-icon-link text-brown"
                    title="Facebook"
                  >
                    <span className="fa fa-stack">
                      <i
                        className="fa fa-stack-2x icon-lv-circle-thin"
                        aria-hidden="true"
                      />
                      <i
                        className="fa fa-stack-1x fa-facebook"
                        aria-hidden="true"
                      />
                    </span>
                    <span className="sr-only">Facebook</span>
                  </a>
                  <a
                    href="https://twitter.com/localvore"
                    className="footer-icon-link text-brown"
                    title="Twitter"
                  >
                    <span className="fa fa-stack">
                      <i
                        className="fa fa-stack-2x icon-lv-circle-thin"
                        aria-hidden="true"
                      />
                      <i
                        className="fa fa-stack-1x fa-twitter"
                        aria-hidden="true"
                      />
                    </span>
                    <span className="sr-only">Twitter</span>
                  </a>
                  <a
                    href="https://instagram.com/localvore/"
                    className="footer-icon-link text-brown"
                    title="Instagram"
                  >
                    <span className="fa fa-stack">
                      <i
                        className="fa fa-stack-2x icon-lv-circle-thin"
                        aria-hidden="true"
                      />
                      <i
                        className="fa fa-stack-1x fa-instagram"
                        aria-hidden="true"
                      />
                    </span>
                    <span className="sr-only">Instagram</span>
                  </a>
                </div>
              </div>
            </section>
            <div className="row">
              <div className="col-12 text-center my-4 footer-smalltext">
                &copy; 2017 Localvore Inc. All Rights Reserved. |{' '}
                <a
                  className="text-nowrap text-gray-dark"
                  href="https://pages.localvore.co/policies"
                >
                  Terms & Privacy
                </a>{' '}
                |{' '}
                <a className="text-nowrap text-gray-dark" href="#fixme-sitemap">
                  Site Map
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    routing: state.routing
  };
}

function mapDispatchToProps(dispatch) {
  return {
    _auth: bindActionCreators(authActions, dispatch)
  };
}

export const FooterContainer = connect(mapStateToProps, mapDispatchToProps)(
  Footer
);



// WEBPACK FOOTER //
// ./src/components/Footer.js